<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <sattva-logo />
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          You are not authorized!
        </h2>
        <p class="mb-2">
          You don’t have permission to access this page.
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="loginRoute()"
        >
          Back to Home
        </b-button>

        <b-img
          fluid
          class="d-block mx-auto misc-not-authorized-img"
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue'
import SattvaLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

const imgLight = require('@/assets/images/pages/not-authorized.svg')
const imgDark = require('@/assets/images/pages/not-authorized-dark.svg')

export default {
  components: {
    BLink, BImg, BButton, SattvaLogo,
  },
  computed: {
    imgUrl() {
      return store.state.appConfig.layout.skin === 'dark' ? imgDark : imgLight
    },
  },
  methods: {
    loginRoute() {
      const user = JSON.parse(localStorage.getItem('userData'))
      return getHomeRouteForLoggedInUser(user.roles[0])
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';

.misc-not-authorized-img {
  max-width: 100%;
  height: auto;
}
</style>
